import { render, staticRenderFns } from "./MailInput.vue?vue&type=template&id=73540166&scoped=true"
import script from "./MailInput.vue?vue&type=script&lang=js"
export * from "./MailInput.vue?vue&type=script&lang=js"
import style0 from "./MailInput.vue?vue&type=style&index=0&id=73540166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73540166",
  null
  
)

export default component.exports